Namespace 'Customer.Filters.Ticket'

class Customer.Filters.Ticket.GroupsFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/groups_filter']
  className: 'filter-field-container groups-filter d-flex'

  initialize: ({filter, groups}) ->
    @filter = filter
    @groups = groups

  render: ->
    @$el.html @template
    @_addGroupsView()
    @

  _addGroupsView: ->
    customerFilter = @filter.get('query')
    @groupsView = new Customer.Filters.GroupsView(terms: @groups, customerFilter: customerFilter)
    @$el.find('#users-group-container').append(@groupsView.render().el)

  getIntelligentGroups: ->
    @groupsView.intelligentGroups()
